import { type MantineSize, Stack, type StackProps, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { icons } from ".."

export function NoData({ children, size = "lg", ...props }: StackProps & { size?: MantineSize }) {
  const { t } = useTranslation()
  const iconSize = size === "xs" ? 24 : size === "sm" ? 28 : size === "md" ? 32 : size === "lg" ? 36 : 40

  return (
    <Stack align="center" gap="xs" c="dimmed" justify="center" fw={500} fz="xl" {...props}>
      <icons.Empty size={iconSize} />
      {children || (
        <Text inherit fz={size}>
          {t("Nothing to show here yet")}
        </Text>
      )}
    </Stack>
  )
}
